import { ProcessesTable } from './ProcessesTable';

export const ProcessesComponent = () => {
  return (
    <>
      <div className='simply-header margin-left-2 margin-bottom-1 margin-top-3'>
        {/* <button className='simply-header__button button-primary font-h5-medium margin-right-1'>New Process</button> */}
        <h2 className='font-h2-medium'>Processes</h2>
      </div>
      <ProcessesTable />
    </>
  );
};
